import script from "./Roadshow.vue?vue&type=script&setup=true&lang=js"
export * from "./Roadshow.vue?vue&type=script&setup=true&lang=js"

import "./Roadshow.vue?vue&type=style&index=0&id=05e08458&lang=scss"

const __exports__ = script;

export default __exports__